/**
 * Manutenção (spec 4.4): reiniciar, restaurar os padrões e o caminho para
 * atualizar o firmware. As duas ações pedem confirmação.
 */
import { Alert, Button, Group, Modal, Stack, Text } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import { IconArrowBackUp, IconRefresh } from '@tabler/icons-react'
import { Link } from 'react-router-dom'

import { Linha } from './Linha'
import type { Mensagem } from './mensagens'

export function SecaoManutencao({
  nome, publicId, podeAgir, ocupado, mensagem, aoReiniciar, aoRestaurar,
}: {
  nome: string
  publicId: string
  podeAgir: boolean
  ocupado: boolean
  mensagem: Mensagem | null
  aoReiniciar: () => Promise<void>
  aoRestaurar: () => Promise<void>
}) {
  const [reiniciar, ctlReiniciar] = useDisclosure(false)
  const [restaurar, ctlRestaurar] = useDisclosure(false)
  const travado = !podeAgir || ocupado

  return (
    <Stack gap="md">
      <Linha rotulo="Reiniciar">
        <Group gap="sm">
          <Button variant="default" leftSection={<IconRefresh size={16} />} onClick={ctlReiniciar.open} disabled={travado}>
            Reiniciar
          </Button>
        </Group>
        <Text size="xs" c="dimmed">O robô desliga e liga de novo. Leva cerca de 10 s para voltar a falar com o Console.</Text>
      </Linha>
      <Linha rotulo="Padrões de fábrica">
        <Group gap="sm">
          <Button variant="default" leftSection={<IconArrowBackUp size={16} />} onClick={ctlRestaurar.open} disabled={travado}>
            Restaurar padrões
          </Button>
        </Group>
        <Text size="xs" c="dimmed">Só Tela e Operação. Wi-Fi, credencial e dono continuam como estão.</Text>
      </Linha>
      <Linha rotulo="Atualizar firmware">
        <Group gap="sm">
          <Button variant="default" component={Link} to={`/robo/frota/${encodeURIComponent(publicId)}`}>
            Ir para o firmware do robô
          </Button>
        </Group>
        <Text size="xs" c="dimmed">
          Pelo ar ou pela USB, no cartão Firmware da página do robô. Sair desta tela fecha a porta USB, que o
          gravador vai usar.
        </Text>
      </Linha>
      {mensagem && <Alert color={mensagem.cor} role="status">{mensagem.texto}</Alert>}

      <Modal opened={reiniciar} onClose={ctlReiniciar.close} title="Reiniciar o robô">
        <Stack gap="sm">
          <Text size="sm">
            Reiniciar <strong>{nome}</strong>? O visor apaga por alguns segundos e o robô volta sozinho.
          </Text>
          <Group justify="flex-end">
            <Button variant="default" onClick={ctlReiniciar.close}>Cancelar</Button>
            <Button onClick={async () => { ctlReiniciar.close(); await aoReiniciar() }}>Reiniciar o robô</Button>
          </Group>
        </Stack>
      </Modal>

      <Modal opened={restaurar} onClose={ctlRestaurar.close} title="Restaurar padrões">
        <Stack gap="sm">
          <Text size="sm">
            Brilho, orientação, intervalo e severidade mínima de <strong>{nome}</strong> voltam ao padrão. Wi-Fi,
            credencial e dono não mudam.
          </Text>
          <Group justify="flex-end">
            <Button variant="default" onClick={ctlRestaurar.close}>Cancelar</Button>
            <Button onClick={async () => { ctlRestaurar.close(); await aoRestaurar() }}>Restaurar padrões</Button>
          </Group>
        </Stack>
      </Modal>
    </Stack>
  )
}
